export default __webpack_public_path__ + "static/FoodSystemPlanning-beaa3ad22b791d240ee4ef100b81d1a3.jpg";